module.exports = __webpack_public_path__ + "img/arrow-left-icon.b5300610.svg";